// extracted by mini-css-extract-plugin
export default {"changeValue":"bn_kW","positive":"bn_kX","negative":"bn_kY"};